export default "/_next/static/images/6b99c93c13261d48ee75cd25fab601ae.jpg";